import {ADD_HISTORY} from '../constants';

export default (state = null, action) => {
  switch (action.type) {
    case ADD_HISTORY:
      return action.payload;
    default:
      return state;
  }
};
